var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('dash',{attrs:{"icon":"fa fa-dollar","titulo":"PAGAMENTOS SGF"},nativeOn:{"click":function($event){return _vm.$router.push({ name: 'Credenciados_Finalizacoes' })}}})}
var staticRenderFns = []

export { render, staticRenderFns }